export default "__VITE_ASSET__c5cea5c1__"